import { get } from "lodash";
import { useEffect, useState } from "react";

import { useGetLocationData } from "~/hooks/locationData";
import { transformTableData } from "~/pages/Editor/EditorCatalogEducationalPrograms/utils";
import {
  useGetGroupsQuery,
  useGetLevelsQuery,
} from "~/schemas/generated/graphql";

import { EntityData, IGroup, ILevel, TableName } from "./types";

const useEntityData = ({ useQuery, getterKey, tableName }, page, count) => {
  const [data, setData] = useState(null);
  const [entityData, setEntityData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { event } = useGetLocationData();

  const {
    data: responseData,
    loading: responseLoading,
    refetch,
  } = useQuery({
    variables: {
      page,
      count,
      ActualOn: event ? event : null,
    },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    setLoading(responseLoading);
    setData(responseData);
  }, [responseData, responseLoading]);

  useEffect(() => {
    data && setEntityData(data);
  }, [data]);

  const tableItems = transformTableData(
    get(entityData, `EducationGetter.${getterKey}.items`) as
      | IGroup[]
      | ILevel[],
    tableName,
  );
  const totalRecords = get(
    entityData,
    `EducationGetter.${getterKey}.total`,
  ) as number;

  return { data, loading, refetch, tableItems, totalRecords };
};

export const useGetGroupsData = (page: number, count: number) =>
  useEntityData(
    {
      useQuery: useGetGroupsQuery,
      getterKey: "getListGroupCurriculum",
      tableName: TableName.group,
    },
    page,
    count,
  ) as EntityData<IGroup>;

export const useGetLevelsData = (page: number, count: number) =>
  useEntityData(
    {
      useQuery: useGetLevelsQuery,
      getterKey: "getListLevelCurriculum",
      tableName: TableName.level,
    },
    page,
    count,
  ) as EntityData<ILevel>;
